import React from 'react';
import BuildingsLoader from '../loaders/BuildingsLoader';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import EquipmentLoader from '../loaders/EquipmentLoader';
import PointTypesLoader from '../loaders/PointTypeLoader';
import IngestStatsLoader, { PointSampleRatesLoader } from '../loaders/IngestStatsLoader';

const SEC_TO_MIN = 1 / 60;
const MS_TO_SEC = 1 / 1000;
export const MS_TO_MINS = MS_TO_SEC * SEC_TO_MIN;

const minsSince = (date) => Math.floor((new Date() - date) * MS_TO_MINS);

const DEFAULT_INTERVAL = '3d';

const DashboardLoader = ({ buildings, date, tick }) => {
  const interval = date == null ? DEFAULT_INTERVAL : `${minsSince(date)}m`;
  const key = `${tick}-${date?.getTime() || 'none'}`;
  return (
    <>
      {/* These don't need to refresh every time the tick changes */}
      <BuildingsLoader />
      <OrganizationsLoader />
      <PointTypesLoader />
      {buildings.map((bid) => (
        <EquipmentLoader key={bid} buildingId={bid} />
      ))}

      {/* These will refresh */}
      <IngestStatsLoader key={key} interval={interval} />
      {buildings.map((bid) => (
        <React.Fragment key={`${bid}-${key}`}>
          <PointSampleRatesLoader buildingId={bid} interval={interval} />
        </React.Fragment>
      ))}
    </>
  );
};

export default DashboardLoader;
